import { createFileRoute, notFound } from '@tanstack/react-router';
import { isImportSlug } from '@aslen/core';
import { ImportWizard } from '@/features/import/import-wizard';

/** Resuming a batch from the history: the wizard decides the step from its status. */
export const Route = createFileRoute('/_app/import/$kind/$batchId')({
  beforeLoad: ({ params }) => {
    if (!isImportSlug(params.kind)) throw notFound();
  },
  component: function ImportBatch() {
    const { kind, batchId } = Route.useParams();
    if (!isImportSlug(kind)) return null;
    return <ImportWizard slug={kind} batchId={batchId} />;
  },
});
